import { memo } from "react"
import { MOBILE_ICONS } from "../../../../data/variables"
import Icon from "../../../../components/Icon"

import './index.scss'

type CustomIconColumn = {
  val: string
}

const CustomIconColumn = memo(({ val }: CustomIconColumn) => {
  const { icon, color, icon_text, color_text } = MOBILE_ICONS[val] ?? {}

  if (icon && color) {
    return (
      <div className="CustomIconColumn">
        <Icon icon={icon} color={color} />
        <span>{`${icon_text} - ${color_text}`}</span>
      </div>
    )
  }
  return null
})

export default CustomIconColumn
